export default __webpack_public_path__ + "static/media/settings_active.d6b1a9a9.svg";